import { NOTIFY_ERROR } from '../../../../vuex/modules/snackbar/types'
import { getAccounts, getPositions } from '../apiCalls'
import * as types from './types'

export default {
  [types.GET_POSITIONS]: async ({ commit, getters }) => {
    commit(types.SET_IS_LOADING, true)

    try {
      const params = getters[types.PARAMS_TO_SEND]
      const { accountId, ...restParams } = params

      const positions = await getPositions(accountId, restParams)

      commit(types.SET_POSITIONS, positions.results)
      commit(types.SET_TOTAL_ITEMS, positions.pagination.total_items)
    } catch (err) {
      console.error(err)
      commit(types.SET_POSITIONS, [])
      commit(types.SET_TOTAL_ITEMS, 0)
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.CHANGE_PAGINATION]({ commit }, newPagination) {
    commit(types.SET_PAGINATION, newPagination)
  },
  [types.CHANGE_FILTERS]({ commit }, { key, value }) {
    commit(types.SET_FILTERS, {
      key,
      value
    })
  },
  [types.RESET_PAGINATION]({ state, dispatch }) {
    dispatch(types.CHANGE_PAGINATION, {
      ...state.pagination,
      page: 1
    })
  },
  [types.GET_ACCOUNTS]: async ({ commit, getters, dispatch }) => {
    try {
      const params = getters[types.PARAMS_TO_SEND]
      const accounts = await getAccounts({ owner_id: params.companyId })
      const results = Object.entries(accounts.results).map(([key, value]) => {
        return {
          key: value.id,
          value: value.name
        }
      })
      commit(types.SET_ACCOUNTS, results)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    }
  }
}
